module.exports = __webpack_public_path__ + "media/12_ASANBUDAPEST-Vibes12.9a00c032.mp3";